export default {
      id: "sli-logout-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#sli-logout",
      toString: function () {
        return this.url;
      }
    }